var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        width: "1060px",
        height: "680px",
        "close-on-click-modal": false,
        "custom-class": "privacy-dialog",
        "before-close": _vm.handleClose,
        "show-close": true,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "span",
        {
          staticStyle: {
            color: "#3855F1",
            "font-family":
              "'Inter Tight', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
            "font-size": "22px",
            "font-weight": "600",
            "line-height": "normal",
          },
          attrs: { slot: "title" },
          slot: "title",
        },
        [_vm._v("Privacy Policy for Indonesia — Personal Users' Version")]
      ),
      _c("div", { staticClass: "privacy-policy-page" }, [
        _c("div", { staticClass: "container" }, [
          _c("h3", [_vm._v("1. Introduction")]),
          _c("p", [
            _vm._v(
              'PayCools HongKong Limited ("Company", "we", "us", or "our") is committed to protecting and respecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your personal data when you use our payment services in Indonesia, and other applicable jurisdictions.'
            ),
          ]),
          _c("h3", [_vm._v("2. Data Controller / Contact Info")]),
          _c("ol", [
            _c("li", [
              _vm._v(
                "PayCools Limited acts as the Data Controller for the purposes of the Perlindungan Data Pribadi (PDP) and other applicable data protection laws."
              ),
            ]),
            _c("li", [
              _vm._v(
                "If you have any questions or requests regarding your personal data, you may contact us at:"
              ),
              _c("br"),
              _vm._v(" Email: [privacy@paycools.com]"),
              _c("br"),
              _vm._v(" Address: [Insert office address if applicable]"),
              _c("br"),
              _vm._v(
                " Data Protection Officer (DPO): [Insert name or position if appointed] - not necessary in law but recommend to do so "
              ),
            ]),
          ]),
          _c("h3", [_vm._v("3. Types of Data Collected")]),
          _c("p", [
            _vm._v(
              "When you use any of the following services, we collect your personal data:"
            ),
          ]),
          _c("ol", [
            _c("li", [_vm._v("Our website")]),
            _c("li", [_vm._v("Any of our applications")]),
            _c("li", [
              _vm._v("Any services offered through our apps or website"),
            ]),
          ]),
          _c("p", [
            _vm._v(
              "We may collect personal data directly from you, through your use of our services, from third-party sources (such as financial institutions, fraud prevention agencies, or public databases), or from other users. This includes, but is not limited to, the following categories:"
            ),
          ]),
          _c("h4", [_vm._v("(1) Information you provide to us")]),
          _c("p", [_vm._v("We collect information you provide when you:")]),
          _c("ul", [
            _c("li", [_vm._v("Fill in forms on our website or app")]),
            _c("li", [_vm._v("Open an account or apply to use our services")]),
            _c("li", [
              _vm._v(
                "Complete identity verification (KYC) or compliance checks"
              ),
            ]),
            _c("li", [
              _vm._v(
                "Correspond with us by phone, email, chat, or social media"
              ),
            ]),
            _c("li", [
              _vm._v(
                "Respond to surveys or participate in promotions or competitions"
              ),
            ]),
            _c("li", [
              _vm._v(
                "Provide information for customer support or dispute resolution"
              ),
            ]),
            _c("li", [
              _vm._v(
                "Connect third-party accounts (e.g., bank accounts, wallets, payment cards) to our services"
              ),
            ]),
          ]),
          _c("p", [_vm._v("This may include:")]),
          _c("ul", [
            _c("li", [
              _vm._v(
                "Identification Data: Full name, date of birth, nationality, gender, copies of identification documents (passport, ID card, driver's license), facial recognition or biometric data used for identity verification."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Contact Information: Residential and billing addresses, email address, phone number, emergency contact information."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Financial Data: Bank account details (IBAN, sort code, SWIFT), payment card details (card number, expiry date, CVV), linked financial accounts, account balances, transaction history."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Business Information (if you are a merchant): Company name, registration number, tax identification number, business licenses/permits, merchant category codes (MCC), ownership and control structure."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Compliance Data: KYC/AML documents, proof of address, tax residency information, sanctions screening results, risk scores, source of funds/wealth information."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Communications: Records of phone calls, chats, emails, or social media interactions with our support team."
              ),
            ]),
          ]),
          _c("h4", [
            _vm._v("(2) Information we collect from your use of our services"),
          ]),
          _c("p", [
            _vm._v(
              "Whenever you interact with our products, we automatically collect:"
            ),
          ]),
          _c("ul", [
            _c("li", [
              _vm._v(
                "Technical Data: IP address, device identifiers (IMEI, MAC address), login credentials, operating system, browser type and version, mobile network information, time zone, device settings, VPN usage, and language settings."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Usage Data: Details of your account activity, services you use, links you click, pages you visit, session times, and interactions within our app or website."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Transaction Data: Incoming and outgoing payments, date, time, currency, amount, counterparties, merchant details, geolocation of transactions (merchant terminal/ATM location), device used, and payment method."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Location Data: If enabled, we may collect geolocation information via GPS or other technologies for fraud prevention and service optimization."
              ),
            ]),
          ]),
          _c("h4", [_vm._v("(3) Information we obtain from third parties")]),
          _c("p", [
            _vm._v(
              "We may receive information about you from trusted external sources, such as:"
            ),
          ]),
          _c("ul", [
            _c("li", [
              _vm._v(
                "Financial Institutions & Payment Partners: Bank account details, linked card information, settlement and chargeback data."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Credit Reference & Fraud Prevention Agencies: Credit history, fraud risk scores, sanctions list checks, information on late payments, bankruptcy, or criminal records (where legally permitted)."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Regulators & Public Authorities: Identity or compliance confirmations as required by law."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Publicly Available Sources: Online registers, company filings, sanctions lists, adverse media reports, and open government databases."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Other Users: For example, if another customer identifies you as a beneficiary, payer, or business counterparty."
              ),
            ]),
          ]),
          _c("h4", [
            _vm._v("(4) Information from social media and online interactions"),
          ]),
          _c("p", [
            _vm._v(
              "Occasionally, we may use publicly available information from social media platforms (LinkedIn, Facebook, Twitter, etc.) to conduct enhanced due diligence checks, confirm identity, or comply with anti-money laundering and sanctions requirements."
            ),
          ]),
          _c("p", [
            _vm._v(
              "If you engage with us on social media (by tagging us, posting on our pages, or participating in promotions), we may collect the information you share."
            ),
          ]),
          _c("h3", [_vm._v("4. Purpose of Processing")]),
          _c("p", [
            _vm._v(
              "We process personal data strictly for lawful and legitimate business purposes, including but not limited to:"
            ),
          ]),
          _c("ol", [
            _c("li", [
              _vm._v(
                "Service Provision – to register merchants, process payments, facilitate pay-ins and pay-outs, and provide customer support."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Regulatory Compliance – to meet obligations under AML, CTF, tax, and financial services regulations."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Risk Management & Fraud Prevention – to detect, investigate, and prevent fraud, money laundering, and other financial crimes."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Contractual Necessity – to perform contractual obligations with merchants and ensure settlement accuracy."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Communication – to send important service updates, legal notices, and respond to inquiries."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Service Improvement – to enhance system performance, develop new products, and conduct analytics."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Legal Claims – to establish, exercise, or defend legal claims where necessary."
              ),
            ]),
          ]),
          _c("h3", [_vm._v("5. Legal Basis")]),
          _c("p", [
            _vm._v(
              "We process your personal data under the following legal bases, as permitted by Perlindungan Data Pribadi (PDP):"
            ),
          ]),
          _c("h3", [_vm._v("6. Sharing & Disclosure")]),
          _c("p", [
            _vm._v(
              "We may share your personal data only in limited circumstances, as described below:"
            ),
          ]),
          _c("ol", [
            _c("li", [
              _vm._v(
                "Service Providers: We share information with trusted third-party service providers who perform functions on our behalf, such as payment processors, KYC/AML verification providers, fraud prevention tools, IT and cloud hosting services."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Affiliates & Group Companies: We may share your data with our subsidiaries or affiliates, provided they adhere to this Privacy Policy."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Regulators & Authorities: We may disclose information where required by law, regulation, or lawful request, including financial regulators, tax authorities, or law enforcement agencies."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Business Transfers: In the event of a merger, acquisition, or sale of assets, your data may be transferred as part of the transaction, subject to the same protection standards."
              ),
            ]),
            _c("li", [
              _vm._v(
                "International Transfers: Where we transfer data outside the Indonesia, we ensure adequate safeguards are in place."
              ),
            ]),
            _c("li", [
              _vm._v(
                "With Your Consent: In specific cases, we may share data with third parties when you have provided explicit consent."
              ),
            ]),
          ]),
          _c("h3", [_vm._v("7. International Transfers")]),
          _c("p", [
            _vm._v(
              "We may transfer and store your personal data outside the Indonesia, including to countries that may not provide the same level of data protection. Where we do so, we ensure that appropriate safeguards are in place, such as:"
            ),
          ]),
          _c("ol", [
            _c("li", [
              _vm._v(
                "Standard Contractual Clauses (SCCs) approved by relevant authorities;"
              ),
            ]),
            _c("li", [
              _vm._v(
                "Transfers to jurisdictions deemed to provide adequate protection by the relevant authorities;"
              ),
            ]),
            _c("li", [
              _vm._v("Binding Corporate Rules (BCRs), where applicable."),
            ]),
          ]),
          _c("p", [
            _vm._v(
              "You may request a copy of the relevant safeguards by contacting us at the details provided in Section 2 above."
            ),
          ]),
          _c("h3", [_vm._v("8. Data Retention")]),
          _c("p", [
            _vm._v(
              "We retain your personal data only for as long as necessary to fulfill the purposes for which it was collected, including to comply with applicable legal, regulatory, accounting, or reporting obligations. The retention period depends on the type of data:"
            ),
          ]),
          _c("ol", [
            _c("li", [
              _vm._v(
                "Transaction Data: Retained for a minimum of 5–7 years to comply with anti-money laundering (AML), tax, and financial record-keeping obligations. Certain records may be retained longer if required by statutory limitation periods or regulatory authorities."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Customer Support Records: Retained for up to 3 years following the closure of your account or your last interaction with us, in order to respond to potential claims or inquiries."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Marketing Data: Retained until you withdraw your consent, opt out of receiving marketing communications, or after a period of 24 months of inactivity, whichever comes first."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Technical and Security Logs: Retained for 12–24 months for system integrity, fraud detection, and security investigation purposes. Longer retention may apply where logs are relevant to an ongoing incident or investigation."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Legal and Contractual Records: Where necessary, certain contracts, consents, and communications may be stored for the duration of the contractual relationship and up to the statutory limitation period."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Data Minimization & Review: We periodically review the personal data we hold to ensure it is not kept longer than necessary. Where possible, we anonymize or aggregate data so that it can no longer identify you and may be used for statistical, analytical, or business purposes without further notice."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Deletion: Once the applicable retention period expires, we will securely delete, anonymize, or irreversibly pseudonymize your data, unless we are legally required to retain it."
              ),
            ]),
          ]),
          _c("h3", [_vm._v("9. User Rights")]),
          _c("p", [
            _vm._v(
              "Under applicable data protection laws, you have the following rights regarding your personal data. You may exercise these rights at any time by contacting us:"
            ),
          ]),
          _c("ol", [
            _c("li", [
              _vm._v(
                "Right of Access – You have the right to obtain confirmation as to whether we process your personal data and to request a copy of such data, along with information on how it is used."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Right to Rectification – You may request correction of any inaccurate or incomplete personal data we hold about you."
              ),
            ]),
            _c("li", [
              _vm._v(
                'Right to Erasure ("Right to be Forgotten") – You may request deletion of your personal data where there is no longer a legitimate reason for us to retain it, subject to legal or regulatory obligations.'
              ),
            ]),
            _c("li", [
              _vm._v(
                "Right to Restrict Processing – You may request that we restrict the processing of your personal data under certain circumstances, such as when the accuracy of the data is contested or when processing is unlawful."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Right to Data Portability – You may request to receive your personal data in a structured, commonly used, and machine-readable format, and to have it transmitted to another controller where technically feasible."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Right to Object – You may object to our processing of your personal data where the processing is based on legitimate interests, including direct marketing activities."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Right to Withdraw Consent – Where processing is based on your consent, you have the right to withdraw that consent at any time, without affecting the lawfulness of prior processing."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Right to Lodge a Complaint – You have the right to lodge a complaint with your local supervisory authority if you believe that your data protection rights have been violated."
              ),
            ]),
          ]),
          _c("p", [
            _vm._v(
              "We will respond to all requests without undue delay and, in any event, within the time limits established by applicable data protection law."
            ),
          ]),
          _c("h3", [_vm._v("10. Security Measures")]),
          _c("p", [
            _vm._v(
              "We take the protection of your personal data seriously and implement appropriate technical and organizational measures to ensure its confidentiality, integrity, and availability. These include:"
            ),
          ]),
          _c("ol", [
            _c("li", [
              _vm._v(
                "Data Encryption: All personal data transmitted between you and our systems is encrypted using industry-standard encryption protocols (e.g., TLS/SSL)."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Access Controls: Access to personal data is strictly limited to authorized personnel with a legitimate business need, and subject to strict authentication procedures."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Data Minimization & Pseudonymization: Wherever possible, we minimize the personal data collected and apply pseudonymization techniques to reduce risk."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Monitoring & Testing: We conduct regular security monitoring, vulnerability scanning, and penetration testing of our systems."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Incident Response: We maintain a documented incident response plan to detect, investigate, and respond to potential data breaches. In the event of a breach, we will notify affected users and relevant supervisory authorities in accordance with applicable law."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Vendor Due Diligence: We require all third-party service providers who process personal data on our behalf to adhere to strict data protection and security standards."
              ),
            ]),
          ]),
          _c("h3", [_vm._v("11. Policy Updates")]),
          _c("p", [
            _vm._v(
              "We may update this Privacy Policy from time to time to reflect changes in our practices, legal requirements, or regulatory guidance."
            ),
          ]),
          _c("ol", [
            _c("li", [
              _vm._v(
                "Notification of Changes: When significant changes occur, we will notify users via email, in-app notification, or prominent notice on our website."
              ),
            ]),
            _c("li", [
              _vm._v(
                'Effective Date: The "Effective Date" of the latest version of this Privacy Policy is clearly stated at the top of the document.'
              ),
            ]),
            _c("li", [
              _vm._v(
                "Your Continued Use: By continuing to use our services after updates are posted, you agree to the revised Privacy Policy. We encourage you to review this Policy periodically to stay informed about how we are protecting your personal data."
              ),
            ]),
          ]),
        ]),
      ]),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              staticStyle: {
                "background-color": "#3855F1",
                color: "#ffffff",
                width: "120px",
                padding: "12px",
                height: "34px",
              },
              attrs: { type: "text" },
              on: { click: _vm.handleClose },
            },
            [_vm._v("Close")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }